import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Typography } from "@material-ui/core";
import get from "lodash/get";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import InvoicesTable from "components/InvoicesToValidate";
import { fetchSettingsByModuleName } from "redux/actions/users";
// Styles repris de l'écran Factures. Pas de pastilles d'extraction ici (retirées le 07/08 à la
// demande du métier) : le niveau d'extraction n'est pas un critère de tri des avoirs.
import useStyles from "pages/Invoices/List/style";
import Filter from "./Components/Filter";

export default function AvoirList() {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	const { t } = useTranslation();
	const [selected, setSelected] = React.useState([]);
	const settings = useSelector(({ requests }) => get(requests, "queries.FETCH_SETTINGS_MODULE.data"));
	const currentUser = useSelector(({ requests }) => get(requests, "queries.FETCH_CURRENT_USER.data"));
	const currentUserPermissions = useMemo(() => get(currentUser, "permissions"), [currentUser]);
	const ids = useSelector(({ requests }) => get(requests, "queries.LIST_FETCH_AVOIRS.data.content", []).map((avoir) => avoir.id));
	useEffect(() => { dispatch(fetchSettingsByModuleName("invoice")); }, [dispatch]);
	const formatSettings = (data) => data && data.reduce((result, { code, value }) => ({ ...result, [code]: parseInt(value, 10) }), {});
	return <Grid spacing={2} xs={12} container className={classes.firstGrid}>
		<Grid container item direction="column"><Typography variant="h6" color="secondary">{t("Avoirs")}</Typography></Grid>
		<Grid item container xs={12}><Filter settings={settings} selected={selected} setSelected={setSelected} handleSelectedAll={(checked) => setSelected(checked ? ids : [])} fromDashboard={Boolean(history.location.state?.fromDashboard)} currentUserPermissions={currentUserPermissions} /></Grid>
		<Grid item xs={12}><InvoicesTable isAvoir settings={formatSettings(settings)} selected={selected} setSelected={setSelected} /></Grid>
	</Grid>;
}
